import React from 'react'
import ReactDOM from 'react-dom'

import './styles.scss'
import { IDialogBaseProps } from './types'

class Dialog extends React.Component<IDialogBaseProps> {
  public static defaultProps = { classes: {} }
  public element = document.createElement('div')

  public componentDidMount() {
    document.body.appendChild(this.element)
  }

  public componentWillUnmount() {
    document.body.removeChild(this.element)
  }

  public render() {
    const { classes, onClose, ...rest } = this.props
    
    return ReactDOM.createPortal(
      <div className="dialogOverlay" {...rest}>
        <div className="dialogArea">
          <div className="dialogBackground" onClick={onClose} />
          <div className={
                `dialogContainer ${ classes?.dialogContainer ? classes.dialogContainer : ''}`
            }
          >
            {this.props.children}
          </div>
        </div>
      </div>,
      this.element
    )
  }
}

export default Dialog
